export default "__VITE_ASSET__Uwm2f4SJ__"